import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import { SousCategorieSchema } from "../../_App/Schemas/SousCategorieSchema";
import {
  createSousCategorieApi,
  updateSousCategorieApi,
} from "../../_App/Redux/Slices/souscategories/souscategorieSlice";
import {
  findCategorieBySocieteApi,
  ListCategories,
  ListCartegoriesParOrganisation,
} from "../../_App/Redux/Slices/categories/categorieSlice";
import Swal from "sweetalert2";

import { CategorieType } from "../../_App/Types/Entites/CategorieType";
import { useTranslation } from "react-i18next";
export default function SousCategorieForm({
  ShowModal,
  setShowModal,
  sousCategorie,
  categorie_id,
  currentOrganisation,
  societe,
}: any) {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const listCategories = useAppSelector(ListCategories);
  const listCartegoriesParOrganisation = useAppSelector(
    ListCartegoriesParOrganisation,
  );
  const [selectedOrganisation, setselectedOrganisation] = useState(true);
  const [list_categories, setlist_categories] = useState<CategorieType[]>([]);
  // init form hooks
  const formOptions = { resolver: yupResolver(SousCategorieSchema) };
  const { register, handleSubmit, reset, formState } = useForm(formOptions);
  const { errors } = formState;
  const [oldQte_min, setoldQte_min] = useState(0);

  useEffect(() => {
    if (sousCategorie) {
      reset({
        libelle: {
          fr: sousCategorie.libelle.fr,
          abr: sousCategorie.libelle.abr || "",
        },
        solde: sousCategorie.solde,
        image: sousCategorie.image,
        categorie_id: sousCategorie.categorie_id,
        minimalStock: Number(sousCategorie.minimalStock) || 0,
      });
      setoldQte_min(Number(sousCategorie.minimalStock) || 0);
      sousCategorie.organisation_id !== null
        ? setselectedOrganisation(true)
        : setselectedOrganisation(false);
    } else {
      reset({
        libelle: {
          fr: "",
          abr: "",
        },
        minimalStock: 0,
        solde: true,
      });
    }
  }, [sousCategorie]);
  useEffect(() => {
    if (societe) {
      dispatch(findCategorieBySocieteApi(societe));
    }
  }, [dispatch, societe]);
  useEffect(() => {
    if (selectedOrganisation) {
      const list = listCartegoriesParOrganisation[currentOrganisation];
      list ? setlist_categories(list) : setlist_categories([]);
    } else {
      setlist_categories(listCategories);
    }
  }, [selectedOrganisation, listCartegoriesParOrganisation, listCategories]);
  const style = document.createElement("style");
  style.innerHTML = `
    .swal2-container {
        z-index: 1000000000000000 !important; /* Ajustez la valeur selon vos besoins */
    }
`;
  document.head.appendChild(style);
  const MsgVerification = (
    data: any,
  ): Promise<{ changeMin: boolean; save: boolean }> => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Vous êtes sûr ?",
        text:
          Number(oldQte_min) !== Number(data.minimalStock)
            ? `Vous voulez modifier la quantité minimale de tous les articles à ${data.minimalStock}`
            : `Vous voulez enregistrer  `,
        icon: "warning",
        showCancelButton: true,
        showDenyButton: Number(oldQte_min) !== Number(data.minimalStock),
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#b2baba",
        confirmButtonText:
          Number(oldQte_min) !== Number(data.minimalStock)
            ? "Enregistrer"
            : "Confirmer",
        cancelButtonText: "Annuler",
        denyButtonText: "Enregistrer et Modifier la quantité ",
      }).then((result) => {
        if (result.isConfirmed) {
          resolve({
            changeMin: false,
            save: true,
          });
        } else if (result.isDenied) {
          resolve({
            changeMin: true,
            save: true,
          });
        } else {
          resolve({
            changeMin: false,
            save: false,
          });
        }
      });
    });
  };
  const onSubmit = async (data: any) => {
    let response;
    if (selectedOrganisation) {
      data.organisation_id = currentOrganisation;
    } else {
      data.organisation_id = null;
    }
    data.societe_id = societe;
    const resp = await MsgVerification(data);
    if (resp.save) {
      const new_data = { ...data, changeMin: resp.changeMin };
      if (sousCategorie && sousCategorie._id) {
        // If the sous categorie has an _id, it means it's an update
        new_data._id = sousCategorie._id;
        console.log("new_data", new_data);
        response = await dispatch(updateSousCategorieApi(new_data));
      } else {
        response = await dispatch(createSousCategorieApi(new_data));
      }

      if (response?.payload?.success) {
        ToastSuccess(response.payload.message);
        reset({
          libelle: {
            fr: "",
            abr: "",
          },

          minimalStock: 0,
        });
        setShowModal(false);
      } else {
        ToastWarning(response.payload.message);
      }
    }
  };

  return (
    <Modal
      show={ShowModal}
      onHide={() => setShowModal(false)}
      className="modal-2"
      dialogClassName="modal-40w"
      backdropClassName="modal-backdrop-2"
    >
      <Modal.Header>
        <Modal.Title>
          {sousCategorie && sousCategorie._id ? (
            <span className="modal-title" id="addCategorieLabel">
              Modifier la Catégorie N° : {sousCategorie?.libelle?.fr}
            </span>
          ) : (
            <span className="modal-title c-primary" id="addCategorieLabel">
              {t("Ajouter une sous categorie")}
            </span>
          )}
        </Modal.Title>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={(e) => {
            setShowModal(false);
            reset({
              libelle: {
                fr: "",
                abr: "",
              },
            });
          }}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                {/* <input
                  type="hidden"
                  placeholder="Id"
                  id="id"
                  {...register("id")}
                /> */}
                <label htmlFor="libellefr">
                  {" "}
                  <span style={{ color: "red" }}>*</span>Libelle fr
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.libelle?.fr ? "is-invalid" : ""
                  }`}
                  id="libellefr"
                  {...register("libelle.fr")}
                />
                <div className="invalid-feedback">
                  {errors?.libelle?.fr &&
                    errors.libelle.fr.message &&
                    errors.libelle.fr.message.toString()}
                </div>
                <label htmlFor="libelleen">
                  {" "}
                  <span style={{ color: "red" }}>*</span>Abréviation
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.libelle?.abr ? "is-invalid" : ""
                  }`}
                  id="libelleen"
                  {...register("libelle.abr")}
                />
                <div className="invalid-feedback">
                  {errors?.libelle?.abr &&
                    errors.libelle.abr.message &&
                    errors.libelle.abr.message.toString()}
                </div>
              </div>
            </div>
            <div className="col-12">
              <label htmlFor="image">
                {" "}
                <span style={{ color: "red" }}>*</span>Image
              </label>
              <div className="input-group mb-3">
                <label className="input-group-text" htmlFor="image">
                  <i className="os-icon os-icon-documents-07"></i>
                </label>
                <input
                  type="file"
                  accept="image/*"
                  className={`form-control ${errors.image ? "is-invalid" : ""}`}
                  id="image"
                  placeholder="image"
                  {...register("image")}
                />
              </div>
              <div className="invalid-feedback">
                {errors.image &&
                  errors.image.message &&
                  errors.image.message.toString()}
              </div>
            </div>
            <div className="col-12">
              <label htmlFor="image"> Stock minimal</label>
              <div className="input-group mb-3">
                <input
                  type="text"
                  className={`form-control ${
                    errors.minimalStock ? "is-invalid" : ""
                  }`}
                  {...register("minimalStock")}
                />
              </div>
              <div className="invalid-feedback">
                {errors.minimalStock &&
                  errors.minimalStock.message &&
                  errors.minimalStock.message.toString()}
              </div>
            </div>
            <div className="col-12">
              <label htmlFor="image"> Soumis au solde</label>
              <div className="input-group mb-3">
                <input
                  type="checkbox"
                  {...register("solde")}
                />
              </div>
              <div className="invalid-feedback">
                {errors.solde &&
                  errors.solde.message &&
                  errors.solde.message.toString()}
              </div>
            </div>
            <div className="col-12">
              <label htmlFor="image">
                {" "}
                <span style={{ color: "red" }}>*</span>categorie
              </label>
              <div className="input-group mb-3">
                <label htmlFor="souscategorie"></label>
                <select
                  className={`form-control ${
                    errors.categorie_id ? "is-invalid" : ""
                  }`}
                  id="carte"
                  {...register("categorie_id")}
                >
                  {list_categories.map((item: any) => (
                    <option key={item._id} value={item._id}>
                      {" "}
                      {item?.libelle?.fr}
                    </option>
                  ))}
                </select>
                <div className="invalid-feedback">
                  {errors?.categorie_id &&
                    errors.categorie_id.message &&
                    errors.categorie_id.message.toString()}
                </div>
              </div>
            </div>
            <div className="n-chk">
              <label className="new-control new-radio radio-classic-primary">
                <input
                  type="radio"
                  checked={selectedOrganisation}
                  onChange={(e) => setselectedOrganisation(true)}
                  value="connectedOnly"
                  className="new-control-input"
                  name="custom-radio-2"
                />
                <span className="new-control-indicator" />
                <p className="fs-15">l'organisation connecté seulement</p>
              </label>
            </div>
            <div className="n-chk">
              <label className="new-control new-radio radio-classic-primary">
                <input
                  type="radio"
                  checked={!selectedOrganisation}
                  onChange={() => setselectedOrganisation(false)}
                  value="allOrganizations"
                  className="new-control-input"
                  name="custom-radio-2"
                />
                <span className="new-control-indicator" />
                <p className="fs-15">Tous les organisations de la societe</p>
              </label>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="reset"
            onClick={(e) => {
              setShowModal(false);
              reset({
                libelle: {
                  fr: "",
                  abr: "",
                },
                minimalStock: 0,
              });
            }}
            className="btn btn-primary-app"
          >
            Annuler
          </Button>
          <Button type="submit" className="btn btn-primary-app">
            Enregistrer
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
